import { NgModule } from '@angular/core';
import { Apollo, APOLLO_OPTIONS, ApolloModule } from 'apollo-angular';
import {
  ApolloClientOptions,
  ApolloLink,
  InMemoryCache
} from '@apollo/client/core';
import { HttpLink } from 'apollo-angular/http';
import { setContext } from '@apollo/client/link/context';
import { split } from '@apollo/client/core';
import { WebSocketLink } from '@apollo/client/link/ws';
import { getMainDefinition } from '@apollo/client/utilities';
import { environment } from 'apps/purchasing-portal/src/environments/environment';

import { AuthStorage } from '@tix/auth/services';

const https = environment.backendUrl;
const wss = environment.wss;

const authCtx = () =>
  setContext(() => {
    try {
      const token = AuthStorage.getItem('token');
      const role = AuthStorage.getItem('role');

      const headers: Record<string, string> = {};
      if (token) headers['Authorization'] = `Bearer ${token}`;
      if (role) headers['x-hasura-role'] = role;

      return { headers };
    } catch (e) {
      console.error('Error setting Apollo Context: ', e);
      return {};
    }
  });

export function wsFn(httpLink: HttpLink): ApolloClientOptions<any> {
  // Create an http link:
  const http = ApolloLink.from([
    authCtx(),
    httpLink.create({
      uri: https
    })
  ]);

  // Create a WebSocket link:
  const wsLink = new WebSocketLink({
    uri: wss,
    options: {
      reconnect: true,
      connectionParams: () => {
        try {
          const token = AuthStorage.getItem('token');
          const role = AuthStorage.getItem('role');

          console.log({ token, role });

          const headers: Record<string, string> = {};
          if (token) headers['Authorization'] = `Bearer ${token}`;
          if (role) headers['x-hasura-role'] = role;

          return { headers };
        } catch (e) {
          console.error('Error setting Apollo Context: ', e);
          return {};
        }
      }
    }
  });

  const link = split(
    // split based on operation type
    ({ query }) => {
      const { kind, operation } = getMainDefinition(query) as any;
      return kind === 'OperationDefinition' && operation === 'subscription';
    },
    wsLink,
    http
  );

  return {
    link,
    cache: new InMemoryCache()
  };
}

@NgModule({
  providers: [
    Apollo,
    {
      provide: APOLLO_OPTIONS,
      useFactory: wsFn,
      deps: [HttpLink]
    }
  ]
})
export class TixCoreApolloModule {}
